import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { MainComponent } from './pages/main/main.component';
import { AuthGuard } from './core/guard/auth/auth.guard';
import { TitleResolver } from './core/resolver/metatitles/metatitles.resolver';
import { NotFoundComponent } from './pages/component/not-found/not-found.component';
import { HelpComponent } from './pages/component/header/help/help.component';
import { RecoverPasswordComponent } from './pages/login/recover-password/recover-password.component';
import { ResetPasswordComponent } from './pages/login/reset-password/reset-password.component';
import { IconComponent } from './pages/icon/icon.component';
import { invoicesRoutes } from './core/routes/invoices-routing.module';
import { usersRoutes } from './core/routes/users-routing.module';
import { settingsRoutes } from './core/routes/settings-routing.module';
import { reportsRoutes } from './core/routes/reports-routing.module';
import { clientsRoutes } from './core/routes/clients-routing.module';
import { ordersRoutes } from './core/routes/orders-routing.module';
import { notesRoutes } from './core/routes/notes-routing.module';
import { campaignsRoutes } from './core/routes/campaigns-routing.module';
import { deliverysRoutes } from './core/routes/deliverys-routing.module';
import { DownloadDocumentsComponent } from './pages/without-login/download-documents/download-documents.component';
import { OrdersDeliveryComponent } from './pages/without-login/orders-delivery/orders-delivery.component';
import { UpdateOrderStageComponent } from './pages/without-login/update-order-stage/update-order-stage.component';
import { telemarketingRoutes } from './core/routes/telemarketing-routing.module';
import { communicationRoutes } from './core/routes/communication-routing.module';

import { NotificationChatComponent } from './pages/demo/notification-chat/notification-chat.component';
import { environment } from '../environments/environment';

// Demo routes — only available in non-production
const demoRoutes: Routes = !environment.production ? [
  { path: 'demo/notification/chat', component: NotificationChatComponent, data: { title: 'Demo — Chat Notificaciones' } },
  ...communicationRoutes.map(r => ({ ...r, path: 'demo/' + r.path })),
] : [];

export const routes: Routes = [
  {
    path: 'public/orders/:reference/documents',
    component: DownloadDocumentsComponent,
    data: {
      title: 'titles-menu-pages.orders',
      public: true
    },
  },
  {
    path: 'public/orders/:reference/update-delivery',
    component: OrdersDeliveryComponent,
    data: {
      title: 'titles-menu-pages.orders',
      public: true
    },
  },
   {
    path: 'public/orders/:reference/update-stage',
    component: UpdateOrderStageComponent,
    data: {
      title: 'titles-menu-pages.orders',
      public: true
    },
  },
  {
    path: 'public/orders/:reference/supplier-update',
    component: OrdersDeliveryComponent,
    data: {
      title: 'titles-menu-pages.orders',
      public: true
    },
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'icon',
        component: IconComponent,
        resolve: { title: TitleResolver },
        data: { title: 'titles-menu-pages.orders' },
      },
      ...notesRoutes,
      ...ordersRoutes,
      ...clientsRoutes,
      ...reportsRoutes,
      ...campaignsRoutes,
      ...deliverysRoutes,
      ...settingsRoutes,
      ...invoicesRoutes,
      ...usersRoutes,
      ...telemarketingRoutes,
      ...communicationRoutes,
      {
        path: 'help',
        component: HelpComponent,
      },
      ...demoRoutes,
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
  },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },

   {
    path: '**',
    redirectTo: '/orders',
  },
];
